import React from 'react';
import { Link } from 'react-router-dom';

const TIERS = [
  {
    name: 'Free',
    tag: 'For every Salesforce admin',
    features: [
      'Connect one org (metadata only — never records)',
      'Object & flow documentation browser',
      'AI descriptions — preview in app',
      'Excel / CSV / PDF exports',
    ],
    cta: { label: 'Start free', href: '/', internal: true },
  },
  {
    name: 'Pro',
    tag: 'The full context engine — coming soon',
    features: [
      'Unlimited scans with history & diff',
      'AI description write-back to your org',
      'Context Packs — markdown bundles your AI agents can read',
      'Graph Explorer — navigate flows, apex, and fields as one graph',
    ],
    cta: {
      label: 'Join the waitlist',
      href: 'mailto:jimbike@gmail.com?subject=ForceSight%20Pro%20waitlist',
      internal: false,
    },
  },
  {
    name: 'Flow Radar',
    tag: 'Flow-failure diagnosis — coming to AppExchange',
    features: [
      'Managed package: every flow failure captured in-org',
      'Root-cause diagnosis on the failure record',
      'Context-aware: cites your fields, types, and recent changes',
      'Cross-flow trends dashboard',
    ],
    cta: {
      label: 'Join the waitlist',
      href: 'mailto:jimbike@gmail.com?subject=Flow%20Radar%20waitlist',
      internal: false,
    },
  },
];

const PricingPage = () => (
  <div className="pricing-page">
    <h1>Pricing</h1>
    <p className="pricing-lede">
      Free for every admin today. Pro and Flow Radar pricing will be announced at
    launch &mdash; join a waitlist and you&rsquo;ll hear it first.
    </p>
    <div className="pricing-grid">
      {TIERS.map((t) => (
        <div key={t.name} className="glass-card pricing-card">
          <h2>{t.name}</h2>
          <p className="pricing-tag">{t.tag}</p>
          <ul>
            {t.features.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
          {t.cta.internal ? (
            <Link className="pricing-cta" to={t.cta.href}>
              {t.cta.label}
            </Link>
          ) : (
            <a className="pricing-cta" href={t.cta.href}>
              {t.cta.label}
            </a>
          )}
        </div>
      ))}
    </div>
    <p className="pricing-footer-links">
      <Link to="/">Home</Link>
      {' '}&middot;{' '}
      <Link to="/flow-radar">Learn about Flow Radar</Link>
    </p>

    <style>{`
      .pricing-page { max-width: 980px; margin: 0 auto; padding: 4rem 1.5rem 5rem; }
      .pricing-page h1 { font-family: var(--font-display); font-size: 2.2rem; letter-spacing: -.02em; color: var(--star-white); margin: 0 0 .5rem; }
      .pricing-lede { color: var(--gray-400); max-width: 58ch; line-height: 1.6; margin: 0 0 2rem; }
      .pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem; }
      .pricing-card { padding: 1.5rem; display: flex; flex-direction: column; }
      .pricing-card h2 { color: var(--star-white); margin: 0; }
      .pricing-tag { color: var(--force-cyan); font-size: .85rem; margin: .3rem 0 1rem; }
      .pricing-card ul { list-style: none; padding: 0; margin: 0 0 1.4rem; display: flex; flex-direction: column; gap: .55rem; flex: 1; }
      .pricing-card li { color: var(--gray-400); font-size: .9rem; line-height: 1.5; padding-left: 1.2rem; position: relative; }
      .pricing-card li::before { content: '✓'; position: absolute; left: 0; color: var(--yoda-green); }
      .pricing-cta { display: block; text-align: center; background: var(--force-cyan); color: #062033; font-weight: 700; border-radius: 8px; padding: .6rem 1rem; text-decoration: none; }
      .pricing-footer-links { text-align: center; color: var(--gray-400); margin-top: 2.5rem; }
      .pricing-footer-links a { color: var(--force-cyan); text-decoration: none; }
    `}</style>
  </div>
);

export default PricingPage;
